<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF ART &HUMANITIES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">About Us</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02">
    <div class="container">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-6 col-xl-7 mt-1-9">
                <div class="col-lg-12 order-2 order-lg-1">
                    <img src="assets/img/ArniSchool03/1.jpg" class="cover-background w-100 h-100"/>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">ABOUT US</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary">The School of Arts and Humanities</h2>
                <p>The School of Arts and Humanities at ARNI University is the place where culture, communication, and
                    creativity take flite to the diversified career opportunities. Arts and Humanities courses offer an
                    enriching blend of disciplines in the arts, literature, philosophy, social science, political
                    science, and history. We are aiming to provide a strong base for creative minds who are passionate
                    about the understanding complexities of human experience, culture, and society, while equipping them
                    with the critical thinking skills and perspectives to thrive in today’s fast-changing world.
                </p>
            </div>
            <div class="col-lg-12 col-xl-12 mt-1-9">
                <p><b>Vision</b> – We have a vision of encouraging educational excellence, providing an inclusive
                    environment
                    that fosters curiosity, cultural understanding, and creativity with courses under arts and
                    humanities. We dream of becoming a globally recognized center for arts and humanities degrees.
                </p>
                <p><b>Mission </b> - our mission is to empower students with a comprehensive understanding of the human
                    experience and the skills needed to navigate the complexities of a globalized society.
                </p>
                <h2>Postgraduate and Undergraduate Courses Under Arts and Humanities</h2>
                <p>Arni University's School of Arts and Humanities is a multicultural, encouraging, and cooperative
                    institution that emphasizes the methodical, academic investigation of current social, political, and
                    economic concerns from an interdisciplinary standpoint. In addition to academic pursuits, it
                    emphasizes students' personal growth. The provided courses are founded on the principles of
                    high-quality education and skill development that lead to career prospects and the overall
                    development of the human being. Students are inspired by the instructors to develop greater
                    awareness and empathy for their peers and fellow citizens. Students' exposure is intended to pave
                    the path for entrepreneurship, industrial requirements, research, internships, global learning, and
                    further education.
                </p>
                <p><b>Scope </b> : Students pursuing commerce or business management courses have diverse opportunities
                    in
                    accounting, finance, marketing, human resources, banking, entrepreneurship, and consulting, with
                    roles in corporate, government, non-profit, and entrepreneurial ventures.
                </p>
                <ul>
                    <li> The School offers a list of courses in arts and humanities that cater to varied academic
                        passions.
                    </li>
                    <li> Students will have the opportunity to integrate knowledge from different fields and polish
                        their knowledge and skills.
                    </li>
                    <li> The potential degree holders may work across various industries, including education, media,
                        communication, publishing, public service, and non-governmental organizations.
                    </li>
                </ul>
                <p>Express your thoughts, explore the cultural heritage, dive into the endless ideas of creativity
                    through our courses, and be a part of this ever-evolving world of arts and humanities. Join us now
                    on the journey of fulfilled growth and opportunities.
                </p>
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>


<!-- COUNTER
        ================================================== -->
<section class="pt-0 ">
    <div class="container ">
        <div class="row mt-n1-9 text-center">
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper text-center">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-01.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">29</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Course</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-02.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">40</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Faculty</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-03.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">7</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Department</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-04.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">20</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Events</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- PARTNER
    ================================================== -->
<section class="bg-very-light-gray py-8">
    <div class="container">
        <div class="client-carousel owl-carousel owl-theme">
            <div class="text-center">
                <img src="assets/img/partners/partner-01.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-02.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-03.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-04.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-05.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-06.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-07.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-08.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-09.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-10.jpg" alt="...">
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <div class="event-schedule-table table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="time">Education</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="time">MA (Economics)</td>
                            </tr>
                            <tr>
                                <td class="time">MA (Geography)</td>
                            </tr>
                            <tr>
                                <td class="time">MA (Hindi)</td>
                            </tr>
                            <tr>
                                <td class="time">MA (History)</td>
                            </tr>
                            <tr>
                                <td class="time">MA (Philosophy)</td>
                            </tr>
                            <tr>
                                <td class="time">MA (Psychology)</td>
                            </tr>
                            <tr>
                                <td class="time">MA (Public Administration)</td>
                            </tr>
                            <tr>
                                <td class="time">MA (Sociology)</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <div class="event-schedule-table table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="time">Journalism & Mass Communication</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="time">BA</td>
                            </tr>
                            <tr>
                                <td class="time">BA (Journalism and Mass Communication)</td>
                            </tr>
                            <tr>
                                <td class="time">MA (Journalism & Mass Communication)</td>
                            </tr>
                            <tr>
                                <td class="time">Ph.D Mass Communication</td>
                            </tr>
                            <tr>
                                <td class="time">Diploma in Mass communication</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <div class="event-schedule-table table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="time">Design</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="time">Bachelor of Fashion Design</td>
                            </tr>
                            <tr>
                                <td class="time">Diploma in Fashion Designing</td>
                            </tr>
                            <tr>
                                <td class="time">B.Des (Fashion)</td>
                            </tr>
                            <tr>
                                <td class="time">M.Des (Fashion Design)</td>
                            </tr>
                            <tr>
                                <td class="time">Diploma in Interior Designing</td>
                            </tr>
                            <tr>
                                <td class="time">Bachelor of Interior Design</td>
                            </tr>
                            <tr>
                                <td class="time">B.Des (Interior Design)</td>
                            </tr>
                            <tr>
                                <td class="time">Master in Interior Designing</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="col-md-12 col-lg-12 col-sm-12">
                    <div class="event-schedule-table table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="time">English</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="time">MA(Eng)</td>
                            </tr>
                            <tr>
                                <td class="time">Ph.D English</td>
                            </tr>
                            <tr>
                                <td class="time">BA(Hons)Eng</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <div class="event-schedule-table table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="time">Library Science</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="time">B.Lib</td>
                            </tr>
                            <tr>
                                <td class="time">M.Lib</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <div class="event-schedule-table table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="time">Yoga Science</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="time">BA(Yoga)</td>
                            </tr>
                            <tr>
                                <td class="time">B.SC(Yoga)</td>
                            </tr>
                            <tr>
                                <td class="time">Diploma in Panchkarma</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <div class="event-schedule-table table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="time">Vocational Courses</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="time">Multimedia</td>
                            </tr>
                            <tr>
                                <td class="time">Animation</td>
                            </tr>
                            <tr>
                                <td class="time">Digital Photography</td>
                            </tr>
                            <tr>
                                <td class="time">Digital marketing</td>
                            </tr>
                            <tr>
                                <td class="time">Digital Film Making</td>
                            </tr>
                            <tr>
                                <td class="time">Graphics Designing</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
